// 課金-ADD-START
import React from "react";
import i18n from "i18next";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { api } from "@/utils/api";
import ConfirmBody from "@/react-components/Confirm/Body";
import ConfirmUpdateTips from "@/react-components/Confirm/Update/Tips";
import { agreementStatusEnum } from "@/utils/enum";

class ConfirmUpdatePaymentAgreement extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: null, isFuture: false };
  }

  componentDidMount() {
    const { contractInfo, updateStatus } = this.props;
    if (contractInfo?.isPayment) {
      this.fetchData();
    } else {
      updateStatus && updateStatus(agreementStatusEnum.paymentAgreementUpdated);
    }
  }

  fetchData = () => {
    api.agreement
      .getLoginUpdatePaymentProtocal()
      .then((response) => {
        if (response?.list && response?.list?.length > 0) {
          this.setState(
            {
              data: {
                content: response?.list[0],
              },
            },
            () => {
              this.fetchTime();
            }
          );
        } else {
          const { updateStatus } = this.props;
          updateStatus &&
            updateStatus(agreementStatusEnum.paymentAgreementUpdated);
        }
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  fetchTime = () => {
    const { data } = this.state;
    const content = data?.content;
    if (content) {
      api.common
        .getTime()
        .then((response) => {
          const isFuture =
            moment(content?.updateDate).format("YYYYMMDD") >
            moment(response).format("YYYYMMDD");
          const { updateStatus } = this.props;
          updateStatus &&
            updateStatus(
              agreementStatusEnum.paymentAgreementWillUpdate,
              isFuture
            );
          this.setState({ isFuture });
        })
        .catch((error) => {
          console.error("error: " + error.message);
        });
    }
  };

  next = () => {
    const { data } = this.state;
    const { authentication } = this.props;
    const content = data?.content;
    api.agreement
      .updateLoginPaymentProtocal({
        userid: authentication?.accountId,
        version: content?.version,
      })
      .then(() => {
        const { updateStatus } = this.props;
        updateStatus &&
          updateStatus(agreementStatusEnum.paymentAgreementUpdated);
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  header = () => {
    const { isFuture, data } = this.state;
    const content = data?.content;
    return (
      <ConfirmUpdateTips
        className="confirm-update-payment-agreement-container-tips"
        text={
          isFuture
            ? moment(content?.updateDate).format(
                i18n.t("TCCs0033_confirm_update_payment_agreement_future_tips")
              )
            : i18n.t("TCCs0033_confirm_update_payment_agreement_tips")
        }
      />
    );
  };

  render() {
    const { data, isFuture } = this.state;
    const content = data?.content;
    return (
      <ConfirmBody
        className="confirm-update-payment-agreement-container"
        header={this.header()}
        title={i18n.t(
          "TCCs0033_confirm_update_payment_agreement_content_title"
        )}
        confirmButtonText={i18n.t(
          "TCCs0033_confirm_update_payment_agreement_button_title"
        )}
        content={content?.contentText}
        onClick={this.next}
        downloadUrl={i18n.t(
          isFuture
            ? "payment_agreement_future_version_download_url"
            : "payment_agreement_applicable_version_download_url"
        )}
        showCheckbox={false}
        notNeedRead={true}
      />
    );
  }
}

ConfirmUpdatePaymentAgreement.propTypes = {
  updateStatus: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    state: state?.user?.authState,
    contractInfo: state?.user?.contractInfo,
    authentication: state?.user?.authentication,
  };
};

export default connect(mapStateToProps)(ConfirmUpdatePaymentAgreement);
// 課金-ADD-END
